import {
  Component,
  OnInit,
  Input,
  OnChanges,
  OnDestroy,
  ViewChild,
  SimpleChanges,
  HostListener,
  AfterContentChecked,
  ChangeDetectorRef,
  Output,
  ElementRef
} from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ReservationService } from '@app/reservation/reservation.service';
import { Point } from 'electron';
import { Options, LabelType } from 'ng5-slider';
import { Subject } from 'rxjs';
import {
  GeneralSettings,
  NameDisplayFormat,
  ReservationBookSettings,
  Room,
  RoomTable
} from '../reservation-settings.model';
import { Reservation } from '@app/reservation/reservation.model';
import { MatTabGroup, MatSnackBar, MatSidenav } from '@angular/material';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService, resStatus } from '@app/core';
import { DxContextMenuComponent } from 'devextreme-angular/ui/context-menu';
import { AddReservationComponent } from '@app/reservation/reservations/add-reservation/add-reservation.component';
import { AddPatternComponent } from './add-pattern/add-pattern.component';
import { ConfirmModalComponent } from '@app/shared/confirm-modal/confirm-modal.component';
import { AddDecorationComponent } from './add-decoration/add-decoration.component';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UtilService } from '@app/core/util.service';

export enum TableType {
  SQUARE = 'Square',
  ROUND = 'Round',
  RECTANGLE = 'Rectangle',
  RECTANGLE_ROTATE = 'Rectangle_Rotated',
  AUTO = 'Auto',
  AUTO_ROTATE = 'Auto_Rotated'
}

@Component({
  selector: 'app-table-plan',
  templateUrl: './table-plan.component.html',
  styleUrls: ['./table-plan.component.scss']
})
export class TablePlanComponent implements OnInit, OnChanges, OnDestroy, AfterContentChecked {
  @ViewChild('room', { static: false }) room: ElementRef;
  @ViewChild('reservationMenu', { static: false }) reservationMenu: DxContextMenuComponent;
  @ViewChild('roomTabsGroup', { static: false }) tabGroup: MatTabGroup;
  @ViewChild('sidenav', { static: false }) sidenav: MatSidenav;
  @Input() isEditing: boolean;
  @Input() reservationBookSettings: ReservationBookSettings;
  @Input() date: any;
  @Input() reservations: any[];
  @Input() restaurantRooms: any[] = [];
  @Input() allowDragging = false;
  @Input() isFullscreen = false;
  @Output() activeRoom: any;
  rooms: any[] = [];
  tablesThatAreNotInTheRoom: any[] = [];
  tablesInTheRoomRoom: any[] = [];
  dragableTables: any[] = [];
  resStatusList: any[] = [];
  allStatus: any[] = resStatus;
  timeValue = 0;
  timeOptions: Options = {
    floor: 0,
    ceil: 0,
    step: 1,
    showTicks: true,
    showTicksValues: true,
    tickStep: 60,
    showSelectionBar: true,
    translate: (timeValue: number, label: LabelType): string => {
      return this.formatTime(timeValue);
    }
  };
  sizeValue: number = localStorage.getItem('tableSizeFactor') ? +localStorage.getItem('tableSizeFactor') * 100 : 100;
  sizeOptions: Options = {
    floor: 50,
    ceil: 150,
    translate: (sizeValue: number, label: LabelType): string => {
      return this.translateService.instant('tablePlan.size') + sizeValue + ' %';
    }
  };
  // zoomValue: number = 100;
  zoomValue: number = localStorage.getItem('zoomSizeFactor')
    ? Math.round(+localStorage.getItem('zoomSizeFactor') * 100)
    : 100;
  zoomOptions: Options = {
    floor: 50,
    ceil: 150,
    translate: (zoomValue: number, label: LabelType): string => {
      return 'Zoom ' + zoomValue + ' %';
    }
  };

  tableSizeFactor: number = localStorage.getItem('tableSizeFactor') ? +localStorage.getItem('tableSizeFactor') : 1;
  zoomSizeFactor: number = localStorage.getItem('zoomSizeFactor') ? +localStorage.getItem('zoomSizeFactor') : 1;
  scale = 100;
  reservationsForRoom: Reservation[] = [];
  selectedReservationTables: RoomTable[];
  roomWidth = 0;
  roomLength = 0;
  tableStartingPositionX = 0;
  tableStartingPositionY = 0;
  contextMenuItems = [
    {
      text: this.translateService.instant('tablePlan.changeType'),
      items: [
        { text: this.translateService.instant('tablePlan.square') },
        { text: this.translateService.instant('tablePlan.round') },
        { text: this.translateService.instant('tablePlan.rectangle') },
        { text: TableType.AUTO }
      ]
    },
    {
      text: this.translateService.instant('tablePlan.rotate'),
      icon: 'pulldown',
      beginGroup: true
    },
    {
      text: this.translateService.instant('tablePlan.copyTableSize'),
      icon: 'unselectall',
      beginGroup: true
    },
    {
      text: this.translateService.instant('tablePlan.removeFromTablePlan'),
      icon: 'trash',
      beginGroup: true
    }
  ];
  reservationMenuItems = [
    {
      text: this.translateService.instant('Neue Reservierung'),
      icon: 'add',
      beginGroup: true
    },
    {
      text: this.translateService.instant('Neuen Walk-In'),
      icon: 'add',
      beginGroup: true
    }
  ];
  statusItems = [
    { text: this.translateService.instant('tablePlan.pending'), color: '#9f9f9f', value: 'pending', isActive: false },
    {
      text: this.translateService.instant('tablePlan.confirmed'),
      color: '#24b314',
      value: 'confirmed',
      isActive: false
    },
    { text: this.translateService.instant('tablePlan.arrived'), color: '#ebb12b', value: 'arrived', isActive: false },
    { text: this.translateService.instant('tablePlan.noShow'), color: '#912f5e', value: 'noShow', isActive: false },
    { text: this.translateService.instant('tablePlan.canceled'), color: '#e65252', value: 'canceled', isActive: false },
    { text: this.translateService.instant('tablePlan.placed'), color: '#1371fe', value: 'placed', isActive: false },
    { text: this.translateService.instant('tablePlan.finished'), color: '#495057', value: 'finished', isActive: false }
  ];
  copiedTableDimensionsAndType: any;
  selectedTableOnClick: any;
  contextMenuStatusItems: any[] = [];
  newOrEditReservationMenu: any[] = [];
  newReservationMenu = [{ text: this.translateService.instant('tablePlan.createNewReservation') }];
  editReservationMenu = [{ text: this.translateService.instant('tablePlan.editReservation') }];
  activeClient: any;
  isDoubleClick = 0;
  reservationContextMenuItems: any = [];
  allDecorations: any[] = [];
  decorationsForRestaurant: any[] = [];
  contextDecorationMenu = [
    {
      text: this.translateService.instant('tablePlan.rotate'),
      icon: 'pulldown'
    },
    {
      text: this.translateService.instant('tablePlan.removeFromTablePlan'),
      icon: 'trash',
      beginGroup: true
    }
  ];
  roomFloorSettings: any;
  patterns: any[] = [];
  isSuperAdmin = false;
  interirorDrawerIsOpened = false;
  dragingOverTable: number;
  dragedReservation: any;
  dragingReservation: any;
  isTableDraging = false;

  tableType = {
    square: {
      width: 80,
      height: 80,
      borderRadius: 4
    },

    round: {
      width: 80,
      height: 80,
      borderRadius: 9999
    },

    rectangle: {
      width: 160,
      height: 80,
      borderRadius: 5
    },

    rotatedRectangle: {
      width: 80,
      height: 160,
      borderRadius: 5
    }
  };
  idOfSelectedReservationFromTable: string;
  generalSettings: GeneralSettings;
  color1: any;
  color2: any;
  color3: any;
  color4: any;
  color5: any;
  readonly defaultTablePlanColor = '#bfbbbb';
  readonly defaultChairColor = '#616161';

  isDraggingReservationToRoom = true;
  private selectedRoomTables: any[] = [];
  private roomOffset: any;
  private ngUnsubscribe: Subject<any> = new Subject();
  private longPressTimer: any;
  private ghostElement: HTMLElement;
  private startingPositionOfTouch: { x: number; y: number };
  temp: any = [];
  filter: any = {
    name: ''
  };
  constructor(
    private reservationService: ReservationService,
    private modalService: NgbModal,
    private snackBar: MatSnackBar,
    private authService: AuthenticationService,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private changeDetector: ChangeDetectorRef,
    public deviceService: DeviceDetectorService,
    private elementRef: ElementRef,
    private utilsService: UtilService
  ) {
    this.getAllStatus();
  }

  ngOnInit() {
    this.getAllTables();
    this.getSettings();
    this.getRooms();
    this.getActiveClient();
    this.reservations = this.sortAndFilterReservations();
    this.temp = [...this.reservations];
    this.getAllDecorations();
    this.getDecorationsForRestaurant();
    this.getRestaturantFloorPatterns();
    this.getRestaurantFloorSettings();
    this.isCurentUserSuperAdmin();

    this.reservationService
      .getSettings()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((settings: any) => {
        this.generalSettings = settings;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.reservations) {
      this.reservations = this.sortAndFilterReservations();
      this.temp = [...this.reservations];
      if (this.activeRoom) {
        this.getReservationsForSelectedRoom();
        this.getValues(this.activeRoom.id);
      }
    }

    if (changes.allowDragging) {
      this.allowDragging = changes.allowDragging.currentValue;
    }
    if (this.activeRoom) {
      this.roomWidth = this.activeRoom.width * 100;
      this.roomLength = this.activeRoom.length * 100;
    }
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  getAllTables() {
    this.reservationService
      .getAllTablesForActiveClient()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        this.tablesInTheRoomRoom = [];
        for (let index = 0; index < response.length; index++) {
          const table = response[index];
          try {
            table.dimensions = table.dimensions ? JSON.parse(table.dimensions) : null;
          } catch (e) {
            console.warn('[getAllTables] corrupted dimensions JSON for table id', table.id, '— skipping parse');
            table.dimensions = null;
          }
          try {
            table.position = table.position ? JSON.parse(table.position) : null;
          } catch (e) {
            console.warn('[getAllTables] corrupted position JSON for table id', table.id, '— treating as no position');
            table.position = null;
          }
          if (!table.isCombined) {
            this.tablesInTheRoomRoom.push(table);
          }
        }
        console.log('[getAllTables] tablesInTheRoomRoom populated:', this.tablesInTheRoomRoom.length);
        if (this.activeRoom) {
          this.getValues(this.activeRoom.id);
        }
      });
  }

  getSettings() {
    this.reservationService
      .getReservationBookSettings()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((settings: any) => {
        const maxCeil = 22 * 60; // hard cap at 22:00
        this.timeOptions = {
          ...this.timeOptions,
          floor: settings.startTime * 60,
          ceil: Math.min(settings.endTime * 60, maxCeil)
        };
        this.timeValueToNow();
      });
  }

  setTimeOnSliderToNow() {
    this.timeValueToNow();
  }

  timeValueToNow() {
    const now = new Date();
    const nowMinutes = now.getHours() * 60 + now.getMinutes();
    const floor = this.timeOptions.floor || 0;
    const ceil = this.timeOptions.ceil || 0;
    this.timeValue = Math.min(Math.max(nowMinutes, floor), ceil);
    if (this.activeRoom) {
      this.getValues(this.activeRoom.id);
    }
  }

  getRooms() {
    this.reservationService
      .getRooms()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: any) => {
        this.rooms = result;
        if (this.rooms.length > 0) {
          if (!this.activeRoom) {
            this.activeRoom = this.rooms[0];
            this.getValues(this.activeRoom.id);
          } else {
            this.activeRoom = this.rooms.find((room: Room) => {
              return this.activeRoom.id === room.id;
            });
            this.getValues(this.activeRoom.id);
          }
          if (this.activeRoom) {
            this.roomWidth = this.activeRoom.width * 100;
            this.roomLength = this.activeRoom.length * 100;
          }
        }
      });
  }

  getActiveClient() {
    this.authService
      .getActiveClient()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((clientData: any) => {
        this.activeClient = clientData;
      });
  }

  isCurentUserSuperAdmin() {
    this.reservationService
      .isActiveMemberSuperAdmin()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any) => {
        if (data && data.data && data.data.type === 'superAdmin') {
          this.isSuperAdmin = true;
        }
      });
  }

  sortAndFilterReservations() {
    if (!this.reservations || !this.reservations.length) {
      // If this.reservations is undefined, return empty array because filter function will throw error
      return [];
    }
    console.log(this.reservations);
    const reservationArray = this.reservations.filter((res: any) => {
      return res.status !== 'canceled' && res.status !== 'noShow' && res.status !== 'finished';
    });

    reservationArray.sort((a: Reservation, b: Reservation) => {
      return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
    });
    return reservationArray;
  }

  onReservationClick(reservation: any) {
    this.isDoubleClick++;
    setTimeout(() => {
      if (this.isDoubleClick === 2) {
        this.openNewReservationModal(reservation, null, false);
      } else if (this.isDoubleClick === 1) {
        if (reservation.tables[0]) {
          this.onReservationSelected(reservation);
        }
      }
      this.isDoubleClick = 0;
    }, 300);
  }

  onObjectClick(object: any) {
    if (this.isEditing) {
      if (this.selectedTableOnClick) {
        this.removeShowAsMovableAttributeFromTable();
        this.removeShowAsMovableAttributeFromDecoration();
      }
      object.showAsMovable = true;
      this.selectedTableOnClick = object;
    }
  }

  removeShowAsMovableAttributeFromTable() {
    for (let i = 0; i < this.dragableTables.length; i++) {
      const t = this.dragableTables[i];
      t.showAsMovable = false;
    }
  }

  removeShowAsMovableAttributeFromDecoration() {
    for (let i = 0; i < this.decorationsForRestaurant.length; i++) {
      const t = this.decorationsForRestaurant[i];
      t.showAsMovable = false;
    }
  }

  refreshStatusOfMenuItems(reservation: any) {
    if (reservation) {
      this.contextMenuStatusItems = this.statusItems;
      for (let i = 0; i < this.contextMenuStatusItems.length; i++) {
        const status = this.contextMenuStatusItems[i];
        if (status.value === reservation.status) {
          status.isActive = true;
        } else {
          status.isActive = false;
        }
      }
    }
  }

  statusItemClick(event: any, reservation: any) {
    const selectedStatus = event.itemData.value;
    reservation.status = selectedStatus;
    this.reservationService
      .editReservation(reservation)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.snackBar.open(this.translateService.instant('tablePlan.reservationStatusChanged'), '', {
          duration: 2000,
          panelClass: ['snackbar-success']
        });
      });
  }

  editPattern(pattern?: any) {
    const appendContainer = 'body';
    const patternsModalRef = this.modalService.open(AddPatternComponent, {
      size: 'lg',
      container: appendContainer
    });

    patternsModalRef.componentInstance.pattern = pattern;
    patternsModalRef.componentInstance.passEntry.pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      this.snackBar.open(this.translateService.instant('tablePlan.patternSaved'), '', {
        duration: 2000,
        panelClass: ['snackbar-success']
      });
      this.getRestaturantFloorPatterns();
      this.getRestaurantFloorSettings();
      patternsModalRef.close();
    });
  }

  createPattern() {
    const appendContainer = 'body';
    const patternsModalRef = this.modalService.open(AddPatternComponent, {
      size: 'lg',
      container: appendContainer
    });

    patternsModalRef.componentInstance.passEntry.pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      this.snackBar.open(this.translateService.instant('tablePlan.patternCreated'), '', {
        duration: 2000,
        panelClass: ['snackbar-success']
      });
      this.getRestaturantFloorPatterns();
      patternsModalRef.close();
    });
  }

  deletePattern(pattern: any) {
    const modalRef = this.modalService.open(ConfirmModalComponent);
    modalRef.componentInstance.title = this.translateService.instant('tablePlan.deletePattern');
    modalRef.componentInstance.message = this.translateService.instant('tablePlan.deletePatternConfirmation');
    modalRef.componentInstance.showInfo = false;
    modalRef.componentInstance.buttonText = this.translateService.instant('tablePlan.yes');
    modalRef.result.then(
      (result: any) => {
        if (result === 'ok') {
          this.reservationService
            .deletePattern(pattern.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              () => {
                this.snackBar.open(this.translateService.instant('tablePlan.patternDeleted'), '', {
                  duration: 2000,
                  panelClass: ['snackbar-success']
                });
                this.getRestaturantFloorPatterns();
                this.getRestaurantFloorSettings();
              },
              err => {
                this.snackBar.open(err.error.msg, '', {
                  duration: 2000,
                  panelClass: ['snackbar-error']
                });
              }
            );
        }
      },
      () => {}
    );
  }

  createDecoration() {
    const appendContainer = 'body';
    const decorationModalRef = this.modalService.open(AddDecorationComponent, {
      size: 'lg',
      container: appendContainer
    });
    decorationModalRef.componentInstance.passEntry.pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      this.snackBar.open(this.translateService.instant('tablePlan.decorationCreated'), '', {
        duration: 2000,
        panelClass: ['snackbar-success']
      });
      this.getAllDecorations();
      decorationModalRef.close();
    });
  }

  editDecoration(decoration: any) {
    const appendContainer = 'body';
    const decorationModalRef = this.modalService.open(AddDecorationComponent, {
      size: 'lg',
      container: appendContainer
    });

    decorationModalRef.componentInstance.decoration = decoration;
    decorationModalRef.componentInstance.passEntry.pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      this.snackBar.open(this.translateService.instant('tablePlan.decorationSaved'), '', {
        duration: 2000,
        panelClass: ['snackbar-success']
      });
      this.getAllDecorations();
      this.getDecorationsForRestaurant();
      decorationModalRef.close();
    });
  }

  deleteDecoration(decoration: any) {
    const modalRef = this.modalService.open(ConfirmModalComponent);
    modalRef.componentInstance.title = this.translateService.instant('tablePlan.deleteDecoration');
    modalRef.componentInstance.message = this.translateService.instant('tablePlan.deleteDecorationConfirmation');
    modalRef.componentInstance.showInfo = false;
    modalRef.componentInstance.buttonText = this.translateService.instant('tablePlan.yes');
    modalRef.result.then(
      (result: any) => {
        if (result === 'ok') {
          this.reservationService
            .deleteDecoration(decoration.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              () => {
                this.snackBar.open(this.translateService.instant('tablePlan.decorationDeleted'), '', {
                  duration: 2000,
                  panelClass: ['snackbar-success']
                });
                this.getAllDecorations();
                this.getDecorationsForRestaurant();
              },
              err => {
                this.snackBar.open(err.error.msg, '', {
                  duration: 2000,
                  panelClass: ['snackbar-error']
                });
              }
            );
        }
      },
      () => {}
    );
  }

  openNewReservationModal(reservation: any, table: any, isWalkIn: boolean) {
    if (this.isEditing) {
      return;
    }
    const time = this.formatTime(this.timeValue);
    const appendContainer = 'body';
    const newReservationModalRef = this.modalService.open(AddReservationComponent, {
      size: 'lg',
      container: appendContainer
    });

    if (reservation) {
      newReservationModalRef.componentInstance.reservation = reservation;
      newReservationModalRef.componentInstance.table = reservation.tables[0];
    } else {
      newReservationModalRef.componentInstance.isWalkIn = isWalkIn;
      newReservationModalRef.componentInstance.defaultDate = this.date;
      newReservationModalRef.componentInstance.selectedTimeOnTablePlanTimeSlider = isWalkIn ? null : time;
      newReservationModalRef.componentInstance.selectedTablePlanTable = table;
    }

    newReservationModalRef.componentInstance.passEntry
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((receivedEntry: any) => {
        this.snackBar.open(this.translateService.instant('tablePlan.reservationCreaterd'), '', {
          duration: 2000,
          panelClass: ['snackbar-success']
        });
        this.getValues(this.activeRoom.id);
        newReservationModalRef.close();
        // this.reservationService
        //   .getAllReservations(this.date, this.date)
        //   .pipe(takeUntil(this.ngUnsubscribe))
        //   .subscribe(response => {
        //     this.reservations = response.reservations;
        //     this.getReservationsForSelectedRoom();
        //     newReservationModalRef.close();
        //   });
      });
  }

  openAddNewReservation(event: any, table: RoomTable) {
    let walkIn = false;

    // if user click on add new walk-in
    if (event.itemIndex === 1) {
      walkIn = true;
    }
    this.openNewReservationModal(null, table, walkIn);
  }

  itemClick(event: any, table: any) {
    const { itemData, itemIndex } = event;

    if (itemIndex !== 0) {
      if (itemData.text === this.translateService.instant('tablePlan.removeFromTablePlan')) {
        this.removeTableFromRoom(table);
        return;
      }

      if (itemData.text === this.translateService.instant('tablePlan.rotate')) {
        const tempWidth = table.dimensions.width;
        table.dimensions.width = table.dimensions.height;
        table.dimensions.height = tempWidth;
        let angle = table.position.angle;
        if (!table.position.angle) {
          angle = 90;
        } else if (table.position.angle === 270) {
          angle = 0;
        } else {
          angle += 90;
        }
        table.position = {
          ...table.position,
          angle
        };
      } else if (itemData.text === this.translateService.instant('tablePlan.copyTableSize')) {
        this.copiedTableDimensionsAndType = { dimensions: table.dimensions, type: table.type };
      } else if (itemData.text === this.translateService.instant('tablePlan.pasteTableSize')) {
        table.dimensions = this.copiedTableDimensionsAndType.dimensions;
        table.type = this.copiedTableDimensionsAndType.type;
      } else {
        if (itemData.text === this.translateService.instant('tablePlan.square')) {
          table.type = TableType.SQUARE;
        } else if (itemData.text === this.translateService.instant('tablePlan.round')) {
          table.type = TableType.ROUND;
        } else if (itemData.text === this.translateService.instant('tablePlan.rectangle')) {
          table.type = TableType.RECTANGLE;
        } else if (itemData.text === this.translateService.instant('tablePlan.auto')) {
          table.type = TableType.AUTO;
        }
        if (table.type === TableType.RECTANGLE) {
          table.dimensions = { width: table.dimensions.width * 2, height: table.dimensions.width, borderRadius: 5 };
        } else if (table.type === TableType.RECTANGLE_ROTATE) {
          table.dimensions = { width: table.dimensions.width, height: table.dimensions.width * 2, borderRadius: 5 };
        } else if (table.type === TableType.SQUARE) {
          const size = Math.max(table.dimensions.width, table.dimensions.height);
          table.dimensions = { width: size, height: size, borderRadius: 4 };
        } else if (table.type === TableType.ROUND) {
          table.dimensions = { width: table.dimensions.width, height: table.dimensions.width, borderRadius: 9999 };
        } else if (table.type === TableType.AUTO) {
          table.dimensions = this.calculateAutoTabledimensions(table, TableType.AUTO);
        } else if (table.type === TableType.AUTO_ROTATE) {
          table.dimensions = this.calculateAutoTabledimensions(table, TableType.AUTO_ROTATE);
        }
      }
      this.reservationService
        .editTable(table)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data: any) => {
          this.getValues(this.activeRoom.id);
        });
    }
  }

  refreshStatusContextTableItems() {
    if (this.copiedTableDimensionsAndType && this.contextMenuItems.length === 4) {
      this.contextMenuItems.splice(3, 0, {
        text: this.translateService.instant('tablePlan.pasteTableSize'),
        icon: 'selectall',
        beginGroup: true
      });
    }
  }

  formatTime(n: any) {
    // tslint:disable-next-line:no-bitwise
    return `0${(n / 60) ^ 0}`.slice(-2) + ':' + ('0' + (n % 60)).slice(-2);
  }

  async getValues(roomId: number, roomOrDataIsChanged: boolean = false) {
    console.log(
      '[getValues] called with roomId:',
      roomId,
      '| tablesInTheRoomRoom count:',
      this.tablesInTheRoomRoom.length
    );
    if (roomOrDataIsChanged) {
      this.dragableTables = [];
    }
    const newTables: any[] = [];
    const newDragableTables: any[] = [];
    try {
      await Promise.all(
        this.tablesInTheRoomRoom.map(async (table: any) => {
          console.log(
            '[getValues] table.roomId:',
            table.roomId,
            'typeof:',
            typeof table.roomId,
            '| roomId:',
            roomId,
            'typeof:',
            typeof roomId,
            '| match:',
            table.roomId === roomId,
            '| position:',
            table.position
          );
          if (table.roomId === roomId) {
            table.dimensions = table.dimensions ? table.dimensions : this.tableType.square;
            table.chairPositions = await this.setChairPositions(table);
            if (table.position) {
              table.isSelected = this.checkIfTableIsSelected(table, roomOrDataIsChanged);
              const isReservedData = this.getTableIsReservedData(table);
              table.isReserved = isReservedData.isReserved;
              table.statusOfCurrentlySelectedReservation = isReservedData.status;

              if (table.statusOfCurrentlySelectedReservation) {
                table.isFree = false;
              } else {
                table.isFree = true;
              }

              const isOutOfRoomRange: boolean = this.checkIfTableIsOutOfRoomRange(this.activeRoom, table);

              if (isOutOfRoomRange) {
                table.position = { angle: table.position.angle, x: 10, y: 10 };
              }
              newDragableTables.push(table);
            } else {
              newTables.push(table);
            }
          }
        })
      );
    } catch (err) {
      console.error('[getValues] Promise.all threw:', err);
    }
    console.log('[getValues] DONE — newDragableTables:', newDragableTables.length, '| newTables:', newTables.length);
    this.tablesThatAreNotInTheRoom = newTables;
    this.dragableTables = newDragableTables;
    console.log('[getValues] dragableTables assigned:', this.dragableTables.length);
    this.getReservationsForSelectedRoom();
  }

  async setChairPositions(table: any): Promise<any[]> {
    if (!table.position) {
      return;
    }
    const { type, dimensions, seats } = table;
    let tables: any[] = [];
    if (type === 'Round') {
      const rotationsDegrees = 360 / seats;
      const a = dimensions.width / 2;
      const b = dimensions.height / 2;

      for (let i = 0; i < seats; i++) {
        const angleDeg = rotationsDegrees * (i + 1);
        const angleRad = (angleDeg * Math.PI) / 180;
        const cos = Math.cos(angleRad);
        const sin = Math.sin(angleRad);
        // Point on ellipse border in table-local coordinates (origin = table top-left)
        const px = a * cos;
        const py = b * sin;
        // Outward normal angle at this ellipse point — perpendicular to the border
        const normalDeg = (Math.atan2(a * sin, b * cos) * 180) / Math.PI;
        const normalRad = (normalDeg * Math.PI) / 180;
        // Circular chair 24×24: 20% visible (~5px), center 7px inward (half=12, 12-5=7)
        const chairLeft = a + px - 12 - Math.cos(normalRad) * 7;
        const chairTop = b + py - 12 - Math.sin(normalRad) * 7;
        tables.push({ position: i + 1, chairLeft, chairTop, normalDeg });
      }
    } else if (type === TableType.SQUARE) {
      const topCount = Math.ceil(seats / 4);
      const bottomCount = Math.ceil(seats / 4);
      const leftCount = Math.floor((seats - topCount - bottomCount) / 2);
      const rightCount = seats - topCount - bottomCount - leftCount;

      const topSpacing = dimensions.width / (topCount || 1);
      for (let i = 0; i < topCount; i++) {
        tables.push({
          position: tables.length + 1,
          translateX: topSpacing * i + (topSpacing / 2 - 17),
          translateY: -10
        });
      }
      const bottomSpacing = dimensions.width / (bottomCount || 1);
      for (let i = 0; i < bottomCount; i++) {
        tables.push({
          position: tables.length + 1,
          translateX: bottomSpacing * i + (bottomSpacing / 2 - 17),
          translateY: dimensions.height - 10
        });
      }
      if (leftCount > 0) {
        const leftSpacing = dimensions.height / leftCount;
        for (let i = 0; i < leftCount; i++) {
          tables.push({
            position: tables.length + 1,
            vertical: true,
            translateX: -11,
            translateY: leftSpacing * i + (leftSpacing / 2 - 18)
          });
        }
      }
      if (rightCount > 0) {
        const rightSpacing = dimensions.height / rightCount;
        for (let i = 0; i < rightCount; i++) {
          tables.push({
            position: tables.length + 1,
            vertical: true,
            translateX: dimensions.width - 7,
            translateY: rightSpacing * i + (rightSpacing / 2 - 18)
          });
        }
      }
    } else {
      const angle = table.position.angle || 0;
      const isVertical = angle === 90 || angle === 270;
      const topCount = Math.ceil(seats / 2);
      const bottomCount = Math.floor(seats / 2);

      if (isVertical) {
        // Chairs on left and right sides (table is rotated 90/270°)
        const leftSpacing = dimensions.height / topCount;
        for (let i = 0; i < topCount; i++) {
          tables.push({
            position: i + 1,
            vertical: true,
            translateX: -11,
            translateY: leftSpacing * i + (leftSpacing / 2 - 18)
          });
        }
        if (bottomCount > 0) {
          const rightSpacing = dimensions.height / bottomCount;
          for (let i = 0; i < bottomCount; i++) {
            tables.push({
              position: topCount + i + 1,
              vertical: true,
              translateX: dimensions.width - 7,
              translateY: rightSpacing * i + (rightSpacing / 2 - 18)
            });
          }
        }
      } else {
        // Chairs on top and bottom sides only
        const topSpacing = dimensions.width / topCount;
        for (let i = 0; i < topCount; i++) {
          tables.push({
            position: i + 1,
            translateX: topSpacing * i + (topSpacing / 2 - 17),
            translateY: -10
          });
        }
        if (bottomCount > 0) {
          const bottomSpacing = dimensions.width / bottomCount;
          for (let i = 0; i < bottomCount; i++) {
            tables.push({
              position: topCount + i + 1,
              translateX: bottomSpacing * i + (bottomSpacing / 2 - 17),
              translateY: dimensions.height - 10
            });
          }
        }
      }
    }
    return tables;
  }

  checkIfTableIsOutOfRoomRange(room: Room, table: RoomTable) {
    if (room.width * 100 < table.position.x || room.length * 100 < table.position.y) {
      return true;
    }
    return false;
  }

  checkIfTableIsSelected(table: RoomTable, roomOrDataIsChanged: boolean): boolean {
    if (!this.selectedReservationTables) {
      return;
    }

    for (let i = 0; i < this.selectedReservationTables.length; i++) {
      const element: any = this.selectedReservationTables[i];
      if (table.id === element.id) {
        return true;
      }
    }
    return false;
  }

  getTableIsReservedData(table: any): any {
    if (this.reservations) {
      const statusesOfReservationInsideTable: any[] = [];
      for (let i = 0; i < this.reservations.length; i++) {
        const reservation = this.reservations[i];
        const reservationStart = this.getTimeInMinutes(new Date(reservation.startDate));
        const reservationEnd = this.getTimeInMinutes(new Date(reservation.endDate));
        if (this.timeValue >= reservationStart && reservationEnd > this.timeValue) {
          const found = reservation.tables.find((t: any) => {
            return t.id === table.id;
          });
          // found reservation for selected time in slider
          if (found) {
            statusesOfReservationInsideTable.push(reservation.status);
          }
        }
      }
      // This part is to check if some reservation has status finsihed and to avoid coloring table to gray if there are new reservation at same time with different status
      // If there are more reservations selected at same time inside table
      if (statusesOfReservationInsideTable.length > 1) {
        // if one of those has status finished return different status so table wont be gray at selected time
        const status = statusesOfReservationInsideTable.find(res => {
          return res !== 'finished';
        });
        return { isReserved: true, status: status };
      } else {
        // there is only one reservation at selected time retunr that status even if it is finsihed
        // then it is ok for table to be gray - color of finished reservation
        return { isReserved: true, status: statusesOfReservationInsideTable[0] };
      }
    }

    return { isReserved: false, status: null };
  }

  getTimeInMinutes(date: Date): number {
    let hours = date.getHours();
    if (hours === 0) {
      hours = 24;
    }
    const mintes = date.getMinutes();
    return hours * 60 + mintes;
  }

  changeRoom(event: any) {
    this.activeRoom = this.rooms[event.index];
    if (this.activeRoom) {
      this.getValues(this.activeRoom.id, true);
      this.roomWidth = this.activeRoom.width * 100;
      this.roomLength = this.activeRoom.length * 100;
    }
    this.tableStartingPositionX = 0;
    this.tableStartingPositionY = 0;
  }

  getReservationsForSelectedRoom() {
    if (this.reservations) {
      this.reservationsForRoom = [];
      this.reservationsForRoom = this.reservations.filter((res: any) => {
        // if (res.tables[0] && this.activeRoom && res.status !== 'canceled' && res.status !== 'noShow') {
        //   return res.tables[0].roomId === this.activeRoom.id;
        // } else {
        //   return;
        // }
        let isPresent = false;
        if (this.activeRoom && res.status !== 'canceled' && res.status !== 'noShow') {
          if (res.tables && res.tables.length > 0) {
            for (let i = 0; i < res.tables.length; i++) {
              if (res.tables[i].roomId === this.activeRoom.id) {
                isPresent = true;
                break;
              }
            }
            return isPresent;
          } else {
            return;
          }
        } else {
          return;
        }
      });

      this.reservationsForRoom.sort((a: any, b: any) => {
        return new Date(a.reservedFor).getTime() - new Date(b.reservedFor).getTime();
      });
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.tablesThatAreNotInTheRoom, event.previousIndex, event.currentIndex);
  }

  onTableDragStart(table: any) {
    this.removeShowAsMovableAttributeFromTable();
    table.showAsMovable = true;
    this.selectedTableOnClick = table;
  }

  onDragEnded(event: any, table: any) {
    this.isTableDraging = true;
    if (this.isEditing) {
      const position: Point = event.source.getFreeDragPosition();
      table.position = {
        angle: table.position.angle,
        x: parseInt((position.x / this.zoomSizeFactor).toFixed(2), 10),
        y: parseInt((position.y / this.zoomSizeFactor).toFixed(2), 10)
      };
      this.reservationService
        .editTable(table)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(response => {
          const updatedTable = response;
          updatedTable.position = JSON.parse(response.position);
          const index = this.dragableTables.findIndex(ta => {
            return ta.id === table.id;
          });
          this.dragableTables[index].position = updatedTable.position;
        });
    }
  }

  async insertTableInRoom(table: RoomTable) {
    let selectedTable = this.tablesThatAreNotInTheRoom.find(t => {
      return t.id === table.id;
    });
    if (selectedTable) {
      this.tablesThatAreNotInTheRoom = this.tablesThatAreNotInTheRoom.filter(t => {
        return t.id !== table.id;
      });
      const topLeftFree =
        !this.dragableTables.some(
          t =>
            t.position &&
            t.dimensions &&
            t.position.x <= 10 &&
            t.position.x + (t.dimensions.width || 80) >= 10 &&
            t.position.y <= 10 &&
            t.position.y + (t.dimensions.height || 80) >= 10
        ) &&
        !this.decorationsForRestaurant.some(
          (d: any) =>
            d.position &&
            d.size &&
            d.position.x <= 10 &&
            d.position.x + (d.size.width || 80) >= 10 &&
            d.position.y <= 10 &&
            d.position.y + (d.size.height || 80) >= 10
        );
      if (topLeftFree) {
        this.tableStartingPositionX = 0;
        this.tableStartingPositionY = 0;
      }
      const tableW = selectedTable.dimensions.width || 80;
      const tableH = selectedTable.dimensions.height || 80;
      const slotMargin = 30;
      const roomW = this.roomWidth || 500;
      const roomH = this.roomLength || 500;
      const startOffset = 10;
      if (this.tableStartingPositionX + tableW + startOffset > roomW) {
        this.tableStartingPositionY += tableH + slotMargin;
        this.tableStartingPositionX = 0;
      }
      if (this.tableStartingPositionY + tableH + startOffset > roomH) {
        this.tableStartingPositionY = 0;
        this.tableStartingPositionX = 0;
      }
      selectedTable.position = {
        x: startOffset + this.tableStartingPositionX,
        y: startOffset + this.tableStartingPositionY
      };
      this.tableStartingPositionX += tableW + slotMargin;
      const borderRadius = table.type === TableType.ROUND ? 9999 : 5;
      const chairPositions = await this.setChairPositions(selectedTable);

      selectedTable = {
        ...selectedTable,
        dimensions: {
          ...selectedTable.dimensions,
          borderRadius
        },
        chairPositions
      };

      this.reservationService
        .editTable(selectedTable)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data: any) => {
          this.dragableTables.push(selectedTable);
        });
    }
  }

  removeTableFromRoom(table: any) {
    this.dragableTables = this.dragableTables.filter(t => {
      return t.id !== table.id;
    });

    this.tablesThatAreNotInTheRoom.push(table);
    table.position = null;
    this.reservationService
      .editTable(table)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        this.getValues(this.activeRoom.id);
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onReservationSelected(reservation: any) {
    if (!reservation.active || reservation.active === false) {
      this.reservations.forEach((res: any) => {
        if (res.active) {
          res.active = false;
        }
      });
      reservation.active = true;
      const tempIndex = this.tabGroup.selectedIndex;
      this.rooms.forEach(room => {
        if (reservation.tables[0].room && room.name === reservation.tables[0].room.name) {
          this.tabGroup.selectedIndex = this.rooms.indexOf(room);
          this.selectedReservationTables = reservation.tables;
          if (tempIndex === this.rooms.indexOf(room)) {
            this.getValues(room.id);
          }
        }
      });
    } else {
      reservation.active = false;
    }
  }

  handleOnTableReservationClick(event: any): void {
    const id = event.reservationId;
    this.idOfSelectedReservationFromTable = `reservation-${id}`;

    this.reservations.forEach((res: any) => {
      if (res.active) {
        res.active = false;
      }
      if (res.id === id) {
        res.active = true;
      }
    });

    const el = document.getElementById(this.idOfSelectedReservationFromTable);
    el.scrollIntoView({ behavior: 'smooth' });
  }

  calculateAutoTabledimensions(table: RoomTable, type: TableType) {
    const dimensions = {
      width: 80,
      height: 80,
      borderRadius: 5
    };

    if (table.seats <= 5) {
      return this.tableType.square;
    } else {
      if (type === TableType.AUTO) {
        dimensions.width = dimensions.width * ((table.seats - 2) / 2);
      } else {
        dimensions.height = dimensions.height * ((table.seats - 2) / 2);
      }
      return dimensions;
    }
  }

  setSizeOfTables() {
    this.tableSizeFactor = this.sizeValue / 100;
  }

  saveCurrentTableFactorSize() {
    localStorage.setItem('tableSizeFactor', this.tableSizeFactor.toString());
  }

  setZoomValueOfTheRoom() {
    this.zoomSizeFactor = this.zoomValue / 100;
  }

  saveCurrentZoomValue() {
    localStorage.setItem('zoomSizeFactor', this.zoomSizeFactor.toString());
  }

  zoomInOrOut(zoom: string) {
    const zoomDiff = zoom === 'in' ? 10 : -10;
    this.zoomSizeFactor = (Math.round(+localStorage.getItem('zoomSizeFactor') * 100) + zoomDiff) / 100;
    localStorage.setItem('zoomSizeFactor', this.zoomSizeFactor.toString());
    this.zoomValue = Math.round(+localStorage.getItem('zoomSizeFactor') * 100);
  }

  onToggleChange() {
    this.interirorDrawerIsOpened = !this.interirorDrawerIsOpened;
    this.sidenav.toggle();
  }

  async updateTableSize(table: any, htmlTable: any, event: MouseEvent) {
    if (this.isEditing && !this.isTableDraging) {
      const borderRadius = table.type === TableType.ROUND ? 9999 : 5;
      table.dimensions = {
        height: Math.round(htmlTable.offsetHeight / this.zoomSizeFactor / this.tableSizeFactor),
        width: Math.round(htmlTable.offsetWidth / this.zoomSizeFactor / this.tableSizeFactor),
        borderRadius
      };
      table.chairPositions = await this.setChairPositions(table);
      this.reservationService
        .editTable(table)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          this.getValues(this.activeRoom.id);
        });
    }
    this.isTableDraging = false;
  }

  onTableResizeStart(event: MouseEvent, table: any, _tableEl: HTMLElement) {
    event.preventDefault();
    event.stopPropagation();

    const startX = event.clientX;
    const startY = event.clientY;
    const startW = table.dimensions.width * this.tableSizeFactor * this.zoomSizeFactor;
    const startH = table.dimensions.height * this.tableSizeFactor * this.zoomSizeFactor;

    const onMouseMove = (e: MouseEvent) => {
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      let newW = Math.max(40, Math.round((startW + dx) / this.tableSizeFactor / this.zoomSizeFactor));
      let newH = Math.max(40, Math.round((startH + dy) / this.tableSizeFactor / this.zoomSizeFactor));
      if (table.type === TableType.SQUARE) {
        const size = Math.max(newW, newH);
        newW = size;
        newH = size;
      }
      table.dimensions = { ...table.dimensions, width: newW, height: newH };
      this.changeDetector.detectChanges();
    };

    const onMouseUp = async (_e: MouseEvent) => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      const borderRadius = table.type === TableType.ROUND ? 9999 : 5;
      table.dimensions = { ...table.dimensions, borderRadius };
      table.chairPositions = await this.setChairPositions(table);
      this.reservationService
        .editTable(table)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(() => {
          this.getValues(this.activeRoom.id);
        });
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  }

  getAllDecorations() {
    this.reservationService
      .getAllDecorations()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(response => {
        this.allDecorations = response;
      });
  }

  getDecorationsForRestaurant() {
    this.reservationService
      .getRestaurantDecorations()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(response => {
        for (let i = 0; i < response.length; i++) {
          const decoration = response[i];
          decoration.size = JSON.parse(decoration.size);
          decoration.position = JSON.parse(decoration.position);
        }
        this.decorationsForRestaurant = response;
      });
  }

  getRestaturantFloorPatterns() {
    this.reservationService
      .getRestaurantFloorPatterns()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        this.patterns = response;
      });
  }

  getRestaurantFloorSettings() {
    this.reservationService
      .getRestaurantFloorSettings()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        this.roomFloorSettings = response;
        this.color4 = (response && response.tablePlanColor) || this.defaultTablePlanColor;
        this.color5 = (response && response.chairColor) || this.defaultChairColor;
      });
  }

  addDecorationToRoom(activeRoomId: number, decoration: any) {
    let size = { height: 80, width: 80 };
    if (decoration.type === 'furniture') {
      size = { height: 150, width: 150 };
    } else if (decoration.type === 'chair') {
      size = { height: 25, width: 25 };
    }
    const decoW = size.width;
    const decoH = size.height;
    const slotMargin = 30;
    const roomW = this.roomWidth || 500;
    const roomH = this.roomLength || 500;
    const decoTopLeftFree =
      !this.dragableTables.some(
        t =>
          t.position &&
          t.dimensions &&
          t.position.x <= 10 &&
          t.position.x + (t.dimensions.width || 80) >= 10 &&
          t.position.y <= 10 &&
          t.position.y + (t.dimensions.height || 80) >= 10
      ) &&
      !this.decorationsForRestaurant.some(
        (d: any) =>
          d.position &&
          d.size &&
          d.position.x <= 10 &&
          d.position.x + (d.size.width || 80) >= 10 &&
          d.position.y <= 10 &&
          d.position.y + (d.size.height || 80) >= 10
      );
    if (decoTopLeftFree) {
      this.tableStartingPositionX = 0;
      this.tableStartingPositionY = 0;
    }
    const position = { x: 10 + this.tableStartingPositionX, y: 10 + this.tableStartingPositionY };
    if (this.tableStartingPositionX + decoW + slotMargin > roomW) {
      this.tableStartingPositionY += decoH + slotMargin;
      this.tableStartingPositionX = 0;
      if (this.tableStartingPositionY > roomH) {
        this.tableStartingPositionY = 0;
        this.tableStartingPositionX = 0;
      }
    } else {
      this.tableStartingPositionX += decoW + slotMargin;
    }
    const newDecorationInRoom: any = {
      clientId: this.activeClient.id,
      roomId: activeRoomId,
      imageId: decoration.id,
      position,
      size
    };
    this.reservationService
      .addNewDecorationInRoom(newDecorationInRoom)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.getDecorationsForRestaurant();
      });
  }

  addInnerWallToRoom(activeRoomId: number) {
    const size = { height: 200, width: 20 };
    const slotMargin = 30;
    const roomW = this.roomWidth || 500;
    const roomH = this.roomLength || 500;
    const wallTopLeftFree =
      !this.dragableTables.some(
        t =>
          t.position &&
          t.dimensions &&
          t.position.x <= 10 &&
          t.position.x + (t.dimensions.width || 80) >= 10 &&
          t.position.y <= 10 &&
          t.position.y + (t.dimensions.height || 80) >= 10
      ) &&
      !this.decorationsForRestaurant.some(
        (d: any) =>
          d.position &&
          d.size &&
          d.position.x <= 10 &&
          d.position.x + (d.size.width || 80) >= 10 &&
          d.position.y <= 10 &&
          d.position.y + (d.size.height || 80) >= 10
      );
    if (wallTopLeftFree) {
      this.tableStartingPositionX = 0;
      this.tableStartingPositionY = 0;
    }
    const position = { x: 10 + this.tableStartingPositionX, y: 10 + this.tableStartingPositionY };
    if (this.tableStartingPositionX + size.width + slotMargin > roomW) {
      this.tableStartingPositionY += size.height + slotMargin;
      this.tableStartingPositionX = 0;
      if (this.tableStartingPositionY > roomH) {
        this.tableStartingPositionY = 0;
        this.tableStartingPositionX = 0;
      }
    } else {
      this.tableStartingPositionX += size.width + slotMargin;
    }
    const newInnerWall: any = {
      clientId: this.activeClient.id,
      roomId: activeRoomId,
      imageId: null,
      position,
      size
    };
    this.reservationService
      .addNewDecorationInRoom(newInnerWall)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.getDecorationsForRestaurant();
      });
  }

  onDecorationDragEnded(event: any, decoration: any) {
    const position: Point = event.source.getFreeDragPosition();
    decoration.position = {
      x: position.x / this.zoomSizeFactor,
      y: position.y / this.zoomSizeFactor
    };
    this.reservationService
      .editDecorationInRoom(decoration)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(response => {
        const updatedDecoration = response;
        updatedDecoration.position = JSON.parse(response.position);
        const index = this.decorationsForRestaurant.findIndex(ta => {
          return ta.id === decoration.id;
        });
        this.decorationsForRestaurant[index].position = updatedDecoration.position;
      });
  }

  updateDecorationSize(decoration: any, decorationHtmlElem: any, event: any) {
    if ((<HTMLElement>event.target).id !== 'dragableHandle') {
      const dimensions = {
        height: Math.round(decorationHtmlElem.offsetHeight / this.zoomSizeFactor / this.tableSizeFactor),
        width: Math.round(decorationHtmlElem.offsetWidth / this.zoomSizeFactor / this.tableSizeFactor)
      };
      decoration.size = dimensions;
      this.reservationService
        .editDecorationInRoom(decoration)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(response => {});
    }
  }

  deleteDecorationFromRoom(decorationId: number) {
    this.reservationService
      .deleteDecorationFromRoom(decorationId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(response => {
        this.getDecorationsForRestaurant();
      });
  }

  decorationClick(event: any, decoration: any) {
    const { itemData } = event;

    if (itemData.text === this.translateService.instant('tablePlan.rotate')) {
      let rotatAng: number = decoration.rotationAngle;
      if (decoration.room_decoration) {
        if (rotatAng < 270) {
          rotatAng += 90;
        } else {
          rotatAng = 0;
        }
      } else {
        // If decoration is a inner wall element
        const tempWidth = decoration.size.width;
        decoration.size.width = decoration.size.height;
        decoration.size.height = tempWidth;
      }

      decoration.rotationAngle = rotatAng;
      this.reservationService
        .editDecorationInRoom(decoration)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(response => {});
    } else if (itemData.text === this.translateService.instant('tablePlan.removeFromTablePlan')) {
      this.deleteDecorationFromRoom(decoration.id);
    }
  }

  onFloorPatternClick(patternId: number) {
    this.roomFloorSettings.roomImageId = patternId;
    this.reservationService
      .updateRestaurantFloorSettings(this.roomFloorSettings)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        this.getRestaurantFloorSettings();
      });
  }

  onSurroundingsPatternClick(patternId: number) {
    this.roomFloorSettings.surroundingsImageId = patternId;
    this.reservationService
      .updateRestaurantFloorSettings(this.roomFloorSettings)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        this.getRestaurantFloorSettings();
      });
  }

  setFloorColor(event: any) {
    this.roomFloorSettings.roomFloorColor = event;
    this.roomFloorSettings.roomPattern = null;
    this.roomFloorSettings.roomImageId = null;
  }

  setSurroundingsColor(event: any) {
    this.roomFloorSettings.surroundingsColor = event;
    this.roomFloorSettings.surroundingsPattern = null;
    this.roomFloorSettings.surroundingsImageId = null;
  }

  setWallColor(event: any) {
    this.roomFloorSettings.wallColor = event;
  }

  setTablePlanColor(event: any) {
    this.roomFloorSettings.tablePlanColor = event;
  }

  setChairColor(event: any) {
    this.roomFloorSettings.chairColor = event;
  }

  getChairColor(): string {
    return (this.roomFloorSettings && this.roomFloorSettings.chairColor) || this.defaultChairColor;
  }

  onColorPickerClose(color: any, colorPicker: number) {
    if (color) {
      this.reservationService
        .updateRestaurantFloorSettings(this.roomFloorSettings)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {});
    }
  }

  getSanitizedSafeUrl(img: string) {
    return this.sanitizer.bypassSecurityTrustStyle(`url(${img})`);
  }

  getSanitizedSafeCssTransformed(
    chairRotationDegrees: number,
    index: number,
    chairTranslateX: number,
    angle: number = 0
  ) {
    return this.sanitizer.bypassSecurityTrustStyle(
      `rotate(${chairRotationDegrees * index + angle}deg) translateX(${chairTranslateX *
        this.tableSizeFactor *
        this.zoomSizeFactor}px)`
    );
  }

  // Drag and drop - change reservation table

  onDragStart(event: DragEvent, reservation: Reservation) {
    const reservationData = {
      end: reservation.endDate,
      reservationId: reservation.id,
      start: reservation.startDate,
      tableId: reservation.isTablePlan,
      peopleCount: reservation.peopleCount
    };

    this.onReservationStartToDrag(reservationData);
    // Hide dragging element
    // event.target.style.opacity = 0;
  }

  // onDrag(event: DragEvent) {}

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent | TouchEvent, table: any) {
    this.dragingOverTable = null;
    const reservation = this.reservations.find(res => {
      return res.id === this.dragingReservation.reservationId;
    });
    this.dragingReservation = null;

    if (!reservation) {
      return;
    }

    reservation.isTablePlan = table.id;
    this.reservationService
      .editReservation(reservation)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        reservation.tables = [{ id: table.id, name: table.name, roomId: table.roomId, seats: table.seats }];
        this.getReservationsForSelectedRoom();
        if (this.activeRoom) {
          this.getValues(this.activeRoom.id);
        }
        this.dragedReservation = null;
      });
  }

  onDragEnd(event: DragEvent) {
    this.dragingReservation = null;

    // event.target.style.opacity = 1;
  }

  onDragLeave(event: DragEvent) {
    this.dragingOverTable = null;
  }

  onDragEnter(event: DragEvent | TouchEvent, table: any) {
    event.preventDefault();
    this.dragingOverTable = table.id;
  }

  onReservationStartToDrag(event: any) {
    if ((this.deviceService.isTablet() || this.deviceService.isMobile()) && !this.allowDragging) {
      return;
    }

    if (!event) {
      this.dragingReservation = null;
    } else {
      this.dragingReservation = event;
    }

    for (let i = 0; i < this.dragableTables.length; i++) {
      const table = this.dragableTables[i];

      // Get all reservations inside table
      const reservationsInTable = this.reservations.filter(res => {
        if (res.tables.length) {
          for (const t of res.tables) {
            if (t.id === table.id) {
              return true;
            }
          }
          return false;
        }
      });

      // Table does not have any reservations
      let canBeDroppedHere = false;

      // If there is more seats over the table then persons in reservation
      if (table.seats >= event.peopleCount) {
        // If table is free(no reservation inside)
        if (reservationsInTable.length === 0) {
          canBeDroppedHere = true;

          // Table has reservations inside
        } else {
          for (let j = 0; j < reservationsInTable.length; j++) {
            const reservation = reservationsInTable[j];
            const clickedReservationStartDate = new Date(event.start).getTime();
            const clickedReservationEndDate = new Date(event.end).getTime();
            const reservationStartTime = new Date(reservation.startDate).getTime();
            const reservationEndTime = new Date(reservation.endDate).getTime();

            // Comparing time of reservation with times of reservations in table and checking can reservation be dropped here
            if (
              (reservationStartTime <= clickedReservationStartDate &&
                reservationEndTime <= clickedReservationStartDate) ||
              (reservationStartTime >= clickedReservationEndDate && reservationEndTime > clickedReservationEndDate) ||
              reservation.status === 'finished'
            ) {
              canBeDroppedHere = true;
            } else {
              canBeDroppedHere = false;
              break;
            }
          }
        }
      }
      table.canMakeDropReservation = canBeDroppedHere;
    }
  }

  onReservationDragEnd() {
    this.dragingReservation = null;
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.selectedTableOnClick) {
      const width = this.selectedTableOnClick.dimensions
        ? this.selectedTableOnClick.dimensions.width
        : this.selectedTableOnClick.size.width;
      const height = this.selectedTableOnClick.dimensions
        ? this.selectedTableOnClick.dimensions.height
        : this.selectedTableOnClick.size.height;

      if (event.key === 'ArrowUp' && this.selectedTableOnClick.position.y > 0) {
        this.selectedTableOnClick.position.y -= 1;
        event.preventDefault();
      } else if (
        event.key === 'ArrowDown' &&
        this.selectedTableOnClick.position.y < this.activeRoom.length * 100 - height
      ) {
        this.selectedTableOnClick.position.y += 1;
        event.preventDefault();
      } else if (event.key === 'ArrowLeft' && this.selectedTableOnClick.position.x > 0) {
        this.selectedTableOnClick.position.x -= 1;
        event.preventDefault();
      } else if (
        event.key === 'ArrowRight' &&
        this.selectedTableOnClick.position.x < this.activeRoom.width * 100 - width
      ) {
        this.selectedTableOnClick.position.x += 1;
        event.preventDefault();
      } else if (event.key === 'Enter') {
        this.reservationService
          .editTable(this.selectedTableOnClick)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(response => {
            this.getValues(this.activeRoom.id);
          });
        this.removeShowAsMovableAttributeFromTable();
        this.selectedTableOnClick = null;
      } else if (event.key === 'Escape') {
        this.removeShowAsMovableAttributeFromTable();
        this.selectedTableOnClick = null;
      }
    }
  }

  dragTouchstart(event: any, reservation: Reservation) {
    this.startingPositionOfTouch = { x: event.touches[0].clientX, y: event.touches[0].clientY };

    let bgColor = '#24b314';

    switch (reservation.status) {
      case 'arrived': {
        bgColor = '#ebb12b';
        break;
      }
      case 'placed': {
        bgColor = '#1371fe';
        break;
      }
      case 'finished': {
        bgColor = '#495057';
        break;
      }
      case 'noShow': {
        bgColor = '#912f5e';
        break;
      }
      case 'canceled': {
        bgColor = '#e65252';
        break;
      }
    }
    const elementId = 'reservation-' + reservation.id;
    this.ghostElement = document.getElementById(elementId).cloneNode(true) as HTMLElement;
    this.ghostElement.setAttribute('id', 'ghost-el-id');
    this.ghostElement.style.visibility = 'hidden';
    this.ghostElement.style.position = 'absolute';
    this.ghostElement.style.zIndex = '1';
    this.ghostElement.style.backgroundColor = bgColor;
    this.ghostElement.style.color = '#fff';
    this.ghostElement.style.maxWidth = '250px';
    if (this.isFullscreen && document) {
      document.getElementById('fullscreenElement').appendChild(this.ghostElement);
    } else {
      document.body.appendChild(this.ghostElement);
    }
    this.handleLongPressOnMobiles(event, reservation);
    // }
  }

  handleLongPressOnMobiles(event: any, reservation: any) {
    this.selectedRoomTables = [];
    for (const table of this.tablesInTheRoomRoom) {
      if (table.roomId === this.activeRoom.id) {
        this.selectedRoomTables.push(table);
      }
    }
    const { x, y } = this.room.nativeElement.getBoundingClientRect();
    this.roomOffset = { left: x, top: y };
    this.onDragStart(event, reservation);
  }

  dragTouchmove(event: TouchEvent) {
    if (!this.allowDragging) {
      return;
    } else {
      event.preventDefault();
    }

    this.isDraggingReservationToRoom = event.touches[0].clientX - this.startingPositionOfTouch.x > 80;
    if (!this.isDraggingReservationToRoom && this.ghostElement.style.visibility === 'hidden') {
      return;
    }

    let draggingOverTable = false;
    const zoom = this.zoomValue / 100;
    const touchPosition = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    this.ghostElement.style.left = event.touches[0].pageX + 'px';
    this.ghostElement.style.top = event.touches[0].pageY + 'px';
    if (this.ghostElement.style.visibility === 'hidden') {
      this.ghostElement.style.visibility = 'visible';
    }

    for (const table of this.selectedRoomTables) {
      if (table.position) {
        const x1 = table.position.x * zoom + this.roomOffset.left;
        const x2 = x1 + table.dimensions.width * zoom;
        const y1 = table.position.y * zoom + this.roomOffset.top;
        const y2 = y1 + table.dimensions.height * zoom;
        if (touchPosition.x >= x1 && touchPosition.x <= x2 && touchPosition.y >= y1 && touchPosition.y <= y2) {
          draggingOverTable = true;
          this.dragingOverTable = table;
          this.onDragEnter(event, table);
        }
      }
    }

    if (!draggingOverTable) {
      this.dragingOverTable = null;
    }
  }

  dragTouchend(event: TouchEvent) {
    // event.preventDefault();
    this.isDraggingReservationToRoom = false;
    this.ghostElement.style.visibility = 'hidden';
    if (this.allowDragging) {
      if (this.dragingOverTable) {
        const reservation = this.reservations.find(res => {
          return res.id === this.dragingReservation.reservationId;
        });
        this.dragingReservation = null;

        reservation.isTablePlan = this.dragingOverTable;
        this.reservationService
          .editReservation(reservation)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((response: any) => {
            this.getValues(this.activeRoom.id);
            this.dragedReservation = null;
          });
      }

      this.dragingReservation = null;
      this.dragingOverTable = null;
    }
    // const el = document.getElementById('ghost-el-id');

    this.ghostElement.remove();
    this.ghostElement = null;
  }

  getAllStatus() {
    this.reservationService
      .getResStatus()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((resStatusList: any) => {
        this.resStatusList = resStatusList;
        this.resStatusList.forEach((item: any) => {
          item['type'] = 'single';
        });
        this.allStatus = this.allStatus.concat(this.resStatusList);
      });
  }

  getTableBackgroundColor(status: string): string {
    const fallbackColor =
      (this.roomFloorSettings && this.roomFloorSettings.tablePlanColor) || this.defaultTablePlanColor;
    if (!status || !this.allStatus || !this.allStatus.length) {
      return fallbackColor;
    }
    const foundStatus = this.allStatus.find(s => s.value === status);
    return foundStatus ? foundStatus.color : fallbackColor;
  }

  lightenColor(hex: string, factor = 0.5): string {
    if (!hex) return 'transparent';
    const h = hex.replace('#', '');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    const lr = Math.round(r * factor + 255 * (1 - factor));
    const lg = Math.round(g * factor + 255 * (1 - factor));
    const lb = Math.round(b * factor + 255 * (1 - factor));
    return `rgb(${lr}, ${lg}, ${lb})`;
  }

  searchReservation() {
    // filter our data
    const filterKeys = Object.keys(this.filter);
    const temp = this.temp.filter((eachObj: any) => {
      return filterKeys.every(eachKey => {
        const that = this;
        if (!that.filter[eachKey] || !that.filter[eachKey].toString().length) {
          // if (
          //   (eachObj.status == 'blocked' && that.filter['status'] !== 'blocked') ||
          //   (!this.bookSettings.showCanceledRes && eachObj.status == 'canceled' && that.filter['status'] !== 'canceled')
          // ) {
          //   return false;
          // }
          return true; // passing an empty filter means that filter is ignored.
        }
        // Search for guest name
        if (eachKey === 'name') {
          if (!eachObj.guestData) {
            return false;
          }
          return (
            (eachObj.guestData[eachKey]
              ? eachObj.guestData[eachKey].toLowerCase().includes(that.filter[eachKey].toLowerCase())
              : false) ||
            (eachObj.guestData['firstName']
              ? eachObj.guestData['firstName'].toLowerCase().includes(that.filter[eachKey].toLowerCase())
              : false) ||
            (eachObj.guestData['company']
              ? eachObj.guestData['company'].toLowerCase().includes(that.filter[eachKey].toLowerCase())
              : false) ||
            (eachObj.id ? eachObj.id.toString().includes(that.filter[eachKey].replace('#', '')) : false)
          );
        }
      });
    });
    this.reservations = temp;
  }

  formatDisplayName(firstName: string | null, lastName: string | null) {
    const displayNameFormat = this.reservationBookSettings.displayNameFormat as NameDisplayFormat;
    return this.utilsService.formatName(firstName, lastName, displayNameFormat);
  }
}
